import { Navigate, useParams } from 'react-router-dom'
import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { getDoctor, doctors } from '@/data/doctors'

const PARTNERS = [1, 2, 3, 4, 5, 6].map((n) => `/assets/images/partners/partners-${n}.png`)

const APPOINTMENT_STEPS = [
  {
    icon: '/assets/images/appointment/icon-appointment-1.png',
    title: 'Make An Appointment',
    text: 'Book online or call our hotline 09610009620 to request a consultation with the doctor of your choice.',
  },
  {
    icon: '/assets/images/appointment/icon-appointment-2.png',
    title: 'Get your service schedule',
    text: 'We confirm your appointment date, time and serial by SMS so you can plan your visit with confidence.',
  },
  {
    icon: '/assets/images/appointment/icon-appointment-3.png',
    title: 'Meet with our doctors',
    text: 'Visit the hospital, complete a quick registration and meet your doctor for examination and advice.',
  },
]

export function DoctorDetail() {
  const { slug } = useParams()
  const doctor = getDoctor(slug)

  if (!doctor) {
    return <Navigate to="/doctors" replace />
  }

  return (
    <>
      <PageBreadcrumb
        title={doctor.name}
        items={[
          { label: 'Home', to: '/' },
          { label: 'About Us', to: '/about' },
          { label: 'Doctors', to: '/doctors' },
          { label: doctor.name },
        ]}
      />

      {/* doctor single section */}
      <section className="doctor-single-section pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="doctor-single-left">
                <div className="image-1 mb-30">
                  <figure className="image-anime">
                    <img src={doctor.detailImage} alt={doctor.name} />
                  </figure>
                </div>
                <div className="section-title gap-2 mb-30">
                  <h2>{doctor.name}</h2>
                  <p>{doctor.qualification}</p>
                </div>
                <ul className="social-icon">
                  <li>
                    <a href="#" aria-label="instagram">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="facebook">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="twitter">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#" aria-label="pinterest">
                      <i className="fa-brands fa-pinterest-p"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="doctor-single-right">
                <div className="doctor-biography">
                  <h3>Biography</h3>
                  <p className="desc">{doctor.bio}</p>
                  <ul className="doctor-info-list">
                    <li>
                      <span className="text-black fw-bold">Occupation:</span>
                      <span>{doctor.occupation}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Experience:</span>
                      <span>{doctor.experience}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Certificates:</span>
                      <span>{doctor.certificates}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Skills:</span>
                      <span>{doctor.skills}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Location:</span>
                      <span>{doctor.location}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Phone:</span>
                      <span>{doctor.phone}</span>
                    </li>
                    <li>
                      <span className="text-black fw-bold">Email:</span>
                      <span>{doctor.email}</span>
                    </li>
                  </ul>
                </div>

                <div className="doctor-awards">
                  <h3>Awards &amp; Hours</h3>
                  <p className="desc">
                    Our specialists are registered with the Bangladesh Medical &amp; Dental Council and are
                    committed to continuous professional development. Consultation hours run from 8:00 AM to
                    8:00 PM (Saturday–Thursday) and 3:00 PM to 8:00 PM on Friday, with 24/7 emergency cover.
                  </p>
                  <div className="doctor-awards-wappper">
                    {doctor.awards.map((award) => (
                      <div className="doctor-awards-item" key={`${award.title}-${award.organisation}`}>
                        <div className="doctor-awards-icon">
                          <figure>
                            <img src={award.icon} alt={award.title} />
                          </figure>
                        </div>
                        <div className="doctor-awards-content">
                          <p className="black-color fw-bold mb-0">{award.title}</p>
                          <p className="mb-0">{award.organisation}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="doctor-skills">
                  <h3>My Skills</h3>
                  <p>
                    Every doctor at Fast Aid Hospital combines careful clinical assessment with clear
                    communication, so patients and families understand the diagnosis, the treatment plan and the
                    next steps.
                  </p>
                  <div className="skill-progress-wapper pt-10">
                    {doctor.skillLevels.map((skill) => (
                      <div className="single-progressbar" key={skill.label}>
                        <div className="progress-title">{skill.label}</div>
                        <div className="progressbar">
                          <div className="progress-bar-count" data-percent={skill.percent}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* appointment section */}
      <section className="appointment-section-2 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="appointment-box">
                <div className="appointment-process-content wow fadeInUp" data-wow-delay=".2s">
                  <div className="section-title">
                    <span className="sub-title">Booking Process</span>
                    <h2>Simple Steps to get our Services</h2>
                  </div>
                  <div className="appointment-process-list">
                    {APPOINTMENT_STEPS.map((step) => (
                      <div className="appointment-process-item" key={step.title}>
                        <div className="appointment-process-icon">
                          <figure>
                            <img src={step.icon} alt={step.title} />
                          </figure>
                        </div>
                        <div className="appointment-process-title">
                          <h3>{step.title}</h3>
                          <p>{step.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="request-quote-box wow fadeInUp" data-wow-delay=".3s">
                  <div className="section-title">
                    <span className="sub-title">Appointement</span>
                    <h2>Book An Appointment</h2>
                  </div>
                  <div className="default-form appointment-form">
                    <form action="#" onSubmit={(event) => event.preventDefault()}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <div className="form-floating field-inner">
                              <input
                                className="form-control"
                                id="fullname"
                                name="fullname"
                                type="text"
                                placeholder="Full Name Here"
                                autoComplete="off"
                              />
                              <label htmlFor="fullname">Name</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <div className="form-floating field-inner">
                              <input
                                className="form-control"
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Email Here"
                                autoComplete="off"
                              />
                              <label htmlFor="email">Email</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <div className="form-floating field-inner">
                              <input
                                className="form-control"
                                id="phone"
                                name="phone"
                                type="text"
                                placeholder="Phone Number Here"
                                autoComplete="off"
                              />
                              <label htmlFor="phone">Phone Number</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <div className="form-floating">
                              <select
                                className="form-select"
                                id="choosedoctor"
                                aria-label="Choose Doctor"
                                defaultValue={doctor.name}
                              >
                                <option value="Choose Doctor">Choose Doctor</option>
                                {doctors.map((item) => (
                                  <option value={item.name} key={item.slug}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="choosedoctor">Choose Doctor</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <div className="form-floating field-inner">
                              <input
                                className="form-control"
                                id="time"
                                name="time"
                                type="time"
                                autoComplete="off"
                              />
                              <label htmlFor="time">Time</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <div className="form-floating field-inner">
                              <textarea
                                id="message"
                                className="form-control"
                                name="message"
                                placeholder="Messege Here"
                                autoComplete="off"
                              ></textarea>
                              <label htmlFor="message">Message</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="appointment-btn-wapper mt-10">
                            <button type="submit" className="theme-button style-1" data-text="Send Message">
                              <span data-text="Send Message">Send Message</span>
                              <i className="fa-solid fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* partners section */}
      <section className="partners-section-1 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <span className="sub-title">Trusted Care</span>
                <h2>Diagnostic &amp; Referral Partners</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="swiper partners-slider">
                <div className="swiper-wrapper">
                  {PARTNERS.map((logo, index) => (
                    <div className="swiper-slide" key={logo}>
                      <div className="partners-item">
                        <div className="partners-image text-center">
                          <figure>
                            <img src={logo} alt={`partners ${index + 1}`} />
                          </figure>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
